<template>
  <TitleWrapper
    :filter-option="true"
    title="CAMPUS_ADMIN"
    tooltip-title="CAMPUS_ADMIN"
    :display-breadcrumb="true"
    :displayed-column-options="csvFilterOptions"
    :already-selected-displayed-column="filtersPayload.displayedColumns"
    :count="filtersCount"
    @applyFilter="emitFiltersPayload($event, invalid)"
    @clear="clearFilters"
    @cancel="cancelHanlder"
  >
    <template v-slot:filterItems>
      <InputFieldWrapper layout-mode="true">
        <UiInput
          v-model.trim="filtersPayload.first_name"
          title="First Name"
          type="text"
          placeholder="SEARCH_BY_FNAME"
          rules="alpha_spaces"
          :filter="FILTERS_LIST.FIRST_NAME"
          @emitQuery="updateQuery"
        ></UiInput>
        <UiInput
          v-model.trim="filtersPayload.last_name"
          title="Last Name"
          type="text"
          placeholder="SEARCH_BY_LNAME"
          rules="alpha_spaces"
          :filter="FILTERS_LIST.LAST_NAME"
          @emitQuery="updateQuery"
        ></UiInput>
        <UiInput
          v-model.trim="filtersPayload.phone"
          title="Phone Number"
          placeholder="Phone Number"
          rules="numeric"
          :filter="FILTERS_LIST.PHONE"
          @emitQuery="updateQuery"
        />
        <UiInput
          v-model.trim="filtersPayload.email"
          title="Email"
          placeholder="Email"
          :filter="FILTERS_LIST.EMAIL"
          @emitQuery="updateQuery"
        />

        <UiDatePicker
          v-model="filtersPayload.date_of_birth_after"
          title="DOB_GT"
          :filter="FILTERS_LIST.DATE_OF_BIRTH_GREATER_THAN"
          @change="birthDateAfter"
          @emitQuery="updateQuery"
        />
        <UiDatePicker
          v-model="filtersPayload.date_of_birth_before"
          title="DOB_LT"
          :filter="FILTERS_LIST.DATE_OF_BIRTH_LESS_THAN"
          @change="birthDateBefore"
          @emitQuery="updateQuery"
        />
        <UiSingleSelect
          v-model.trim="filtersPayload.login_enabled"
          title="STATUS"
          :options="LOGIN_ENABLED_STATUSES"
          input-color="bg-white"
          label="title"
          reduce="value"
          :filter="FILTERS_LIST.LOGIN_ENABLED_STATUS"
          @emitQuery="updateQuery"
        />
        <UiSingleSelect
          v-model.trim="filtersPayload.gender"
          title="Gender"
          :options="GENDERS"
          input-color="bg-white"
          label="title"
          reduce="value"
          :filter="FILTERS_LIST.GENDER"
          @emitQuery="updateQuery"
        />
        <UiInput
          v-model.trim="filtersPayload.address"
          title="Address"
          type="text"
          placeholder="Address"
          :filter="FILTERS_LIST.ADDRESS"
          @emitQuery="updateQuery"
        />
        <UiSingleSelect
          v-if="!currentCampusScope"
          v-model.trim="filtersPayload.campus_id"
          title="CAMPUSES"
          label="title"
          :options="campuses"
          reduce="id"
          :filter="FILTERS_LIST.CAMPUS"
          @emitQuery="updateQuery"
        />
      </InputFieldWrapper>
    </template>
  </TitleWrapper>
</template>

<script>
import UiInput from '@components/UiElements/UiInputBox.vue'
import TitleWrapper from '@src/components/TitleWrapper.vue'
import UiSingleSelect from '@/src/components/UiElements/UiSingleSelect.vue'
import UiDatePicker from '@components/UiElements/UiDatePicker.vue'
import GENERAL_CONSTANT, { USER_CONSTANTS } from '@src/constants/general-constants'
import { mapActions, mapState } from 'vuex'
import { FILTERS_LIST } from '@src/constants/filter-constants.js'
import { getCountFromObject, removeEmptyKeysFromObject } from '@utils/generalUtil'
import filterMixins from '@/src/mixins/filter-mixins.js'
import InputFieldWrapper from '@/src/components/UiElements/InputFieldWrapper.vue'
export default {
  components: {
    UiInput,
    TitleWrapper,
    UiDatePicker,
    UiSingleSelect,
    InputFieldWrapper,
  },
  mixins: [filterMixins],
  props: {
    csvFilterOptions: {
      type: Array,
      default: () => [],
    },
    alreadySelectedDisplayedColumns: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      FILTERS_LIST,
      GENDERS: USER_CONSTANTS.GENDERS,
      LOGIN_ENABLED_STATUSES: USER_CONSTANTS.LOGIN_ENABLED_STATUSES,
      filtersCount: GENERAL_CONSTANT.EMPTY_RECORD,
      filtersPayload: {
        first_name: '',
        last_name: '',
        email: '',
        gender: '',
        address: '',
        phone: '',
        campus_id: '',
        date_of_birth_before: '',
        date_of_birth_after: '',
        login_enabled: '',
        displayedColumns: [],
      },
    }
  },
  computed: {
    ...mapState({
      currentCampusScope: (state) => state.layout.currentCampusScope || null,
      campuses: (state) => state.layout.campuses || null,
    }),
  },

  watch: {
    currentCampusScope: {
      handler() {
        this.clearFilters()
      },
    },
  },
  mounted() {
    this.updateDisplayedColumnList()
  },
  methods: {
    getFiltersCount() {
      return getCountFromObject(this.filtersPayload, 'displayedColumns', 'boolean')
    },
  },
}
</script>
